import React from 'react';
import { SessionEvent } from '../../../services/sessionModels';
import { EventReason } from '../../../services/sessionsPrepare';
import { SvgIcon } from '@material-ui/core';
import LocalHospitalIcon from '@material-ui/icons/LocalHospital';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';

type Props = {
  event: SessionEvent;
  x: number;
  timelineY: number;
  graphicWidth: number;
  graphicHeight: number;
  isHomeTeam: boolean;
};

const SessionTimelineEvent = (props: Props) => {
  const { event, x, timelineY, graphicWidth, graphicHeight, isHomeTeam } = props;

  const distanceFromTimeline: number = 55;
  let icon: any = <></>;
  let iconColor: string = '#00a';
  switch (event.reason) {
    case EventReason.Substitution:
      icon = <ExitToAppIcon />;
      iconColor = '#777';
      break;
    case EventReason.Injury:
      icon = <LocalHospitalIcon />;
      iconColor = '#e967cd';
      break;
    case EventReason.RedCard:
      icon = <rect x={graphicWidth * 0.125} y={0} width={graphicWidth * 0.5} height={graphicHeight} fill="#a00" />;
      iconColor = '#a00';
      break;
    default:
      break;
  }

  return (
    <>
      {/*Event graphic*/}
      {
        <line
          x1={x}
          x2={x}
          y1={timelineY}
          y2={
            timelineY +
            (isHomeTeam ? -(distanceFromTimeline - graphicHeight * 0.5) : distanceFromTimeline - graphicHeight * 0.5)
          }
          stroke="#00a"
          strokeWidth={2}
          strokeOpacity={0.8}
        />
      }
      {
        <SvgIcon
          x={x - graphicWidth * 0.5}
          width={graphicWidth}
          height={graphicHeight}
          y={timelineY - graphicHeight * 0.5 + (isHomeTeam ? -distanceFromTimeline : distanceFromTimeline)}
          htmlColor={iconColor}
          opacity={0.8}>
          {icon}
        </SvgIcon>
      }
    </>
  );
};

export default SessionTimelineEvent;
